import React from 'react';
import { Plus, X, Flag } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';

const BrandsTab = ({ settings, updateSetting, updateBrand, addBrand, removeBrand }) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Popüler Markalar</CardTitle>
            <CardDescription>Marka vitrinini düzenleyin</CardDescription>
          </div>
          <div className="flex items-center gap-2">
            <Switch
              checked={settings.brands_enabled}
              onCheckedChange={(v) => updateSetting('brands_enabled', v)}
            />
            <Button size="sm" variant="outline" onClick={addBrand}>
              <Plus className="w-4 h-4 mr-1" /> Marka Ekle
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 mb-4">
          <Label>Bölüm Başlığı</Label>
          <Input
            value={settings.brands_title}
            onChange={(e) => updateSetting('brands_title', e.target.value)}
            placeholder="Popüler Markalar"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {settings.brands?.map((brand, index) => (
            <div key={index} className="border rounded-lg p-3 relative group">
              <button
                onClick={() => removeBrand(index)}
                className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <X className="w-3 h-3" />
              </button>
              <div className="flex items-center justify-between mb-2">
                <Switch
                  checked={brand.enabled}
                  onCheckedChange={(v) => updateBrand(index, 'enabled', v)}
                />
                <div className="flex items-center gap-1">
                  <Flag className="w-3 h-3 text-red-600" />
                  <span className="text-xs text-muted-foreground">Türkiye</span>
                  <Switch
                    checked={brand.made_in_turkey || false}
                    onCheckedChange={(v) => updateBrand(index, 'made_in_turkey', v)}
                    className="scale-75"
                  />
                </div>
              </div>
              <img 
                src={brand.logo} 
                alt={brand.name}
                className="w-full h-12 object-contain mb-2 bg-gray-50 rounded"
              />
              <Input
                value={brand.name}
                onChange={(e) => updateBrand(index, 'name', e.target.value)}
                className="h-7 text-xs mb-1"
                placeholder="Marka Adı"
              />
              <Input
                value={brand.logo}
                onChange={(e) => updateBrand(index, 'logo', e.target.value)}
                className="h-7 text-xs mb-1"
                placeholder="Logo URL"
              />
              <Input
                value={brand.link}
                onChange={(e) => updateBrand(index, 'link', e.target.value)}
                className="h-7 text-xs"
                placeholder="Link"
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BrandsTab;
